<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
  >
    <v-row>
      <!-- QUERY DATE-RANGE -->
      <v-col cols="12" lg="5">
        <v-row>
          <v-col cols="12" md="6" class="pb-0"  v-if="achByTrustAccount">
            <v-select
              v-model="form.filter.targetType"
              :items="targetTypes"
              item-text="label"
              item-value="value"
              label="出帳對象類型"
              outlined
              dense
              @change="onTargetTypeChange"
            >
            </v-select>
          </v-col>
          <v-col cols="12" md="6" class="pb-0"  v-if="achByTrustAccount">
            <v-select
              v-model="form.filter.targetId"
              :items="targetEntities"
              :item-text="targetEntityDisplayKey"
              item-value="id"
              label="選擇出帳對象"
              outlined
              dense
              :disabled="!form.filter.targetType || targetEntities.length === 0"
              :loading="isLoadingTargets"
            >
            </v-select>
          </v-col>
          <v-col cols="12" class="pt-0 pb-0">
            <v-radio-group row v-model="form.ach.accountingPeriod">
              <template v-slot:label>
                <div>{{ $t('views.remittances.billingCycle') }}<br></div>
              </template>
              <v-radio :label="$t('views.remittances.weekly')" value="1w"></v-radio>
              <v-radio :label="$t('views.remittances.monthly')" value="1m"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col class="py-2">
            <DateRangePicker @update="onDateRangeUpdated"
              :def-dates="dates">
            </DateRangePicker>
          </v-col>
        </v-row>
      </v-col>

      <!-- SEARCH -->
      <v-col cols="12" sm="6" lg="4">
        <v-card class="my-0" style="height: 100%;">
          <v-card-text>
            <v-container>
              <v-row align="end">
                <v-col cols="12" class="pa-0">
                  <v-radio-group row v-model="form.search.searchBy" @change="search">
                    <template v-slot:label>
                      <div>{{ $t('views.merchants.searchBy') }}<br></div>
                    </template>
                    <v-radio :label="$t('views.merchants.merchantId')" value="merchantId"></v-radio>
                  </v-radio-group>
                </v-col>
                <v-col cols="12" class="pa-0">
                  <v-form @submit.native.prevent @submit="search">
                    <v-text-field outlined prepend-icon="mdi-magnify"
                      v-model="form.search.keyword"
                      placeholder="(Press ENTER to search)" clearable>
                    </v-text-field>
                  </v-form>
                </v-col>
                 <!-- Acquirer filter -->
                <v-col v-if="!achByTrustAccount" cols="12" class="pa-0">
                  <v-select v-model="scope.acquirerId" :items="acquirers" 
                    hide-details
                    item-text="name" item-value="id"
                    :placeholder="$t('views.remittances.selectAcquirer')">
                  </v-select>
                </v-col>

              </v-row>
            </v-container>  
          </v-card-text>
        </v-card>
          
      </v-col>

      <v-col cols="12" sm="6" lg="2" style="height: 100%;" class="d-flex align-start flex-column">
        <v-btn x-large block color="warning" @click="exportCSV">
          <v-icon left>mdi-file-export</v-icon>
          結帳
        </v-btn>
        <v-btn block large color="grey darken-3" @click="forceRefresh">
          <v-icon>mdi-refresh</v-icon>
          {{ $t('views.remittances.refreshButton') }}
        </v-btn>
        <v-btn x-large block color="success" @click="exportRemittancesList">
          <v-icon left>mdi-file-export</v-icon>
          {{ $t('views.remittances.downloadExcel') }}
        </v-btn>
        <!-- <v-btn block large color="error" @click="openTransferDialog">
          <v-icon left>mdi-file-upload-outline</v-icon>
          {{ $t('views.remittances.transferButton') }}
        </v-btn> -->
      </v-col>

      <!-- LIST OF ORDERS -->
      <v-col cols="12">

        <v-card class="mt-0">
          <v-card-title v-if="!achByTrustAccount">
            <span>點點全球股份有限公司撥款帳戶：應付店家 ＝ 所有店家匯費 ＋ 手續費 + 店家加減項 + 點點加減項 總合	</span>
          </v-card-title>
          <v-card-title>      
            <span> {{ !achByTrustAccount ? '其它商店：' : '' }}
            {{ $t('views.remittances.transferAmount')}} = 
                {{$t('views.remittances.amount')}} 
              - {{$t('views.remittances.serviceFee') }} 
              - {{$t('views.remittances.transferFee') }}
              - 店家加減項
            </span>
          </v-card-title>
          <v-card-subtitle class="mt-1" v-if="selectedTrustAccountAcquirers">      
           含收單機構：{{ selectedTrustAccountAcquirers }}
          </v-card-subtitle>
          <v-card-text>
            <SSRTable ref="list-remittances"
              :data-url="loadUrl" :data-key="'remittances'" :schema="schema">

              <div slot="recipient" slot-scope="{item}">
                <span> {{item.recipient_bank_name}} </span><br/>
                <span> {{item.recipient_bank}} </span><br/>
                <span> {{item.recipient_name}} </span><br/>
                <span> {{item.recipient_no}} </span>
                
              </div>

              <div slot="invoice" slot-scope="{item}">
                <span v-if="item.invoice_type==='b2b'"> {{$t('views.remittances.invoice.B2B')}} </span>
                <span v-else-if="item.invoice_type==='b2c'"> {{$t('views.remittances.invoice.B2C')}} </span><br/>
                <span> {{item.invoice_email}} </span><br/>
                <span> {{item.invoice_title}} </span><br/>
                <span> {{item.invoice_tax_id}} </span>
                
              </div>

              <div slot="amount" slot-scope="{item}">
                $ {{ Number(item.amount).toLocaleString() }}
              </div>
              <div slot="service_fee" slot-scope="{item}">
                $ {{ Number(item.service_fee).toLocaleString() }}
              </div>
              <div slot="transfer_fee" slot-scope="{item}">
                $ {{ Number(item.transfer_fee).toLocaleString() }}
              </div>
              <!-- <div slot="supplementary_withholding" slot-scope="{item}">
                {{ Number(item.supplementary_withholding) }}
              </div> -->
              <!-- <div slot="transfer_amount" slot-scope="{item}">
                $ {{ Number(item.transfer_amount).toLocaleString() }}
              </div> -->
              <div slot="payable" slot-scope="{item}">
                $ {{ Number(item.payable).toLocaleString() }}
              </div>
              <div slot="actions" slot-scope="{item}">
                <v-btn rounded depressed small color="blue" class="ml-1"
                  @click="showDialogOfLedgers(item)">
                  <v-icon left>mdi-list-box-outline</v-icon>
                  交易明細
                </v-btn>
              </div>
            </SSRTable>

          </v-card-text>
        </v-card>

      </v-col>
    </v-row>

    <v-dialog v-model="dialog.ledgers.show">
      <v-card>
        <v-card-title>
          Ledgers 
        </v-card-title>
        <v-card-text>
          <SSRTable ref="ledgers" :data-url="loadLedgersUrl" :data-key="'ledgers'" :schema="ledgerSchema">
            <div slot="amount" slot-scope="{item}">
                $ {{ Number(item.amount).toLocaleString() }}
            </div>
            <div slot="serviceFee" slot-scope="{item}">
                $ {{ Number(item.serviceFee).toLocaleString() }}
            </div>
            <div slot="createdAt" slot-scope="{item}" class="py-1">
              <span>{{ tsToDateString(item.createdAt) }}</span>
            </div>
            <div slot="settledAt" slot-scope="{item}" class="py-1">
              <span>{{ tsToDateString(item.settledAt)  }}</span>
            </div>
          </SSRTable>
        </v-card-text>
        <v-card-actions>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import SSRTable from '@/components/SSRTable';
  import DateRangePicker from '@/components/DateRangePicker';

  import axios from 'axios';
  import moment from 'moment';

  export default {
    components: {
      SSRTable,
      DateRangePicker,
      // ScopeSelector,
    },
   
    async mounted() {
      // 先撈取收單行和信託帳戶資料
      await this.fetchAcquirers();
      if (this.achByTrustAccount) {
        await this.fetchTrustAccounts();
        // 設定預設出帳類型為信託帳戶
        this.form.filter.targetType = 'trust_account';
      } else {
        this.form.filter.targetType = 'acquirer';
      }
      
      // 載入信託帳戶列表
      await this.fetchTargetEntities();
      // 設定預設選擇第一個帳戶
      if (this.targetEntities.length > 0) {
        this.form.filter.targetId = this.targetEntities[0].id;
      }
    },

    methods: {
      onDateRangeUpdated(dates) {
        this.dates = dates;
      },
      search() {
        if (this.form.search.searchBy && this.form.search.keyword && this.form.search.keyword.length) {
          this.form.search.queryString = `&${this.form.search.searchBy}=${this.form.search.keyword}`;
          // this.form.search.queryString = `&searchBy=${this.form.search.searchBy}&searchKeyword=${this.form.search.keyword}`;
        } else {
          this.form.search.queryString = '';
        }
        //NOTE: search keyword turns null when 'cleared' by user??
      },
      forceRefresh() {
        this.$refs['list-remittances'].loadData();
      },

      fetchAcquirers() {
        axios.get(`${process.env.VUE_APP_QRPAY_ADMIN_HOST}/api/acquirers`)
        .then(response => {
          this.acquirers = response.data;
          this.scope.acquirerId = this.acquirers.length ? this.acquirers[0].id : null;
        })
        .catch(err => {
          this.$notify({
            text: err?.response?.data?.message || 'Could not fetch acquirers.',
            type: 'error'
          });
        });
      },

      async fetchTrustAccounts() {
        // TODO: 等 API ready 後改用真實 API
        try {
          const url = `${process.env.VUE_APP_QRPAY_ADMIN_HOST}/api/trust-accounts`;
          const response = await axios.get(url);
          this.trustAccounts = response.data;
        } catch (err) {
          this.$notify({
            text: err?.response?.data?.message || 'Could not fetch trust accounts.',
            type: 'error'
          });
        }
      },

      async onTargetTypeChange() {
        // 重置目標ID
        this.form.filter.targetId = null;
        this.targetEntities = [];

        if (!this.form.filter.targetType) {
          return;
        }

        // 根據類型獲取對應的實體列表
        await this.fetchTargetEntities();

        // 設定預設選擇第一個選項
        if (this.targetEntities.length > 0) {
          this.form.filter.targetId = this.targetEntities[0].id;
        }
      },

      async fetchTargetEntities() {
        if (!this.form.filter.targetType) {
          return;
        }

        this.isLoadingTargets = true;
        const targetType = this.form.filter.targetType;

        try {
          switch(targetType) {
            case 'trust_account':
              // 使用已經撈取的信託帳戶資料
              this.targetEntities = this.trustAccounts;
              break;
            case 'acquirer':
              // 使用已經撈取的 acquirers 資料
              this.targetEntities = this.acquirers;
              break;
            // case 'organization':
            //   // 假設有一個API端點來獲取組織列表
            //   const orgResponse = await axios.get(`${process.env.VUE_APP_QRPAY_ADMIN_HOST}/api/organizations`);
            //   this.targetEntities = orgResponse.data;
            //   break;
            // case 'merchant':
            //   // 假設有一個API端點來獲取商店列表
            //   const merchantResponse = await axios.get(`${process.env.VUE_APP_QRPAY_ADMIN_HOST}/api/merchants`);
            //   this.targetEntities = merchantResponse.data;
            //   break;
            default:
              this.isLoadingTargets = false;
              return;
          }
        } catch (err) {
          this.$notify({
            text: err?.response?.data?.message || `無法獲取${this.getTargetTypeLabel()}列表`,
            type: 'error'
          });
          this.targetEntities = [];
        } finally {
          this.isLoadingTargets = false;
        }
      },

      getTargetTypeLabel() {
        const targetType = this.targetTypes.find(t => t.value === this.form.filter.targetType);
        return targetType ? targetType.label : '';
      },

      exportRemittancesList() {
        let from = moment(this.dates[0]).startOf('day');
        let to = moment(this.dates[1]).endOf('day');
        let url = '';
        if (this.achByTrustAccount) {
          if (!this.form.filter.targetType || !this.form.filter.targetId) {
            this.$notify({
              text: '請選擇出帳對象',
              type: 'warning'
            });
            return;
          }
          url = `${process.env.VUE_APP_QRPAY_ADMIN_HOST}/api/v2/remittances/export?timeFormat=${encodeURIComponent('YYYY/M/D h:mm:ssA')}`
            + `&from=${from.unix()}&to=${to.unix()}&accountingPeriod=${this.form.ach.accountingPeriod}`;
            // 根據選擇的類型添加 acquirerIds 參數
          if (this.form.filter.targetType === 'trust_account') {
            // 信託帳戶：使用該帳戶關聯的所有 acquirer IDs
            const selectedAccount = this.targetEntities.find(t => t.id === this.form.filter.targetId);
            if (selectedAccount && selectedAccount.acquirers && selectedAccount.acquirers.length > 0) {
              const acquirerIds = selectedAccount.acquirers.map(a => a.id).join(',');
              url += `&acquirerIds=${acquirerIds}&trustAccountId=${this.form.filter.targetId}`;
            }
          } else if (this.form.filter.targetType === 'acquirer') {
            // 收單行：直接使用選中的 ID
            url += `&acquirerIds=${this.form.filter.targetId}`;
          }
        } else {
          url = `${process.env.VUE_APP_QRPAY_ADMIN_HOST}/api/remittances/export?timeFormat=${encodeURIComponent('YYYY/M/D h:mm:ssA')}`
          + `&from=${from.unix()}&to=${to.unix()}&accountingPeriod=${this.form.ach.accountingPeriod}`
          + `${this.scope.acquirerId? `&acquirerId=${this.scope.acquirerId}`: ''}`;

        }
        

        window.open(url);
      },
      exportCSV() {
        // 一定要選擇出帳對象
        if (!this.form.filter.targetType || !this.form.filter.targetId) {
          this.$notify({
            text: '請選擇出帳對象',
            type: 'warning'
          });
          return;
        }

        let from = moment(this.dates[0]).startOf('day');
        let to = moment(this.dates[1]).endOf('day');
        let url = '';
       

        if (this.achByTrustAccount) {
          if (!this.form.filter.targetType || !this.form.filter.targetId) {
            this.$notify({
              text: '請選擇出帳對象',
              type: 'warning'
            });
            return;
          }
         url = `${process.env.VUE_APP_QRPAY_ADMIN_HOST}/api/v2/remittances/exportCSV?timeFormat=${encodeURIComponent('YYYY/M/D h:mm:ssA')}`
          + `&from=${from.unix()}&to=${to.unix()}&accountingPeriod=${this.form.ach.accountingPeriod}`;

            // 根據選擇的類型添加 acquirerIds 參數
          if (this.form.filter.targetType === 'trust_account') {
            // 信託帳戶：使用該帳戶關聯的所有 acquirer IDs
            const selectedAccount = this.targetEntities.find(t => t.id === this.form.filter.targetId);
            if (selectedAccount && selectedAccount.acquirers && selectedAccount.acquirers.length > 0) {
              const acquirerIds = selectedAccount.acquirers.map(a => a.id).join(',');
              url += `&acquirerIds=${acquirerIds}&trustAccountId=${this.form.filter.targetId}`;
            }
          } else if (this.form.filter.targetType === 'acquirer') {
            // 收單行：直接使用選中的 ID
            url += `&acquirerIds=${this.form.filter.targetId}`;
          }
        } else {
          url = `${process.env.VUE_APP_QRPAY_ADMIN_HOST}/api/remittances/exportCSV?timeFormat=${encodeURIComponent('YYYY/M/D h:mm:ssA')}`
          + `&from=${from.unix()}&to=${to.unix()}&accountingPeriod=${this.form.ach.accountingPeriod}`
          + `${this.scope.acquirerId? `&acquirerId=${this.scope.acquirerId}`: ''}`;
        }
        
        let result = axios.get(url).then(result => {
          let fileurl = result?.data?.fileurl;
          if (fileurl) {
            window.open(fileurl);
            // // Construct the 'a' element
            // var link = window.document.createElement("a");
            // link.download = 'test.csv';
            // link.target = "_blank";

            // // Construct the URI
            // link.href = fileurl;
            // window.document.body.appendChild(link);
            // link.click();

            // // Cleanup the DOM
            // window.document.body.removeChild(link);
          } else {
            this.$notify({
              text: 'Something went wrong. Please retry.',
              type: 'error'
            });
          }
        })
        .catch(err => {
          console.log('err', err)
          this.$notify({
            text: err?.response?.data?.message || 'Something went wrong. Please retry.',
            type: 'error'
          });
        });
      },

      tsToDateString(ts) {
        if (ts) {
          return moment.unix(ts).format('YYYY/MM/DD HH:mm:ss');
        }
        return '';
      },

     
      submit() {
        // if (!confirm('You are about to submit the ACH requests to bank. Sure to continue?'))
        //   return;
        if (!confirm('You are about to download ACH transfer file. Sure to continue?'))
          return;

        let refId = this.dialog.upload.refId;
        if (!refId) {
          console.error(`[Transfer] No ref ID?!!`);
          return;
        }

        window.open(`${process.env.VUE_APP_QRPAY_ADMIN_HOST}/api/ach/preview/${refId}`)
      },
      showDialogOfLedgers(item) {
        let from = moment(this.dates[0]).startOf('day').format('YYYYMMDD');
        let to = moment(this.dates[1]).endOf('day').format('YYYYMMDD');
        this.dialog.ledgers.model.from = from;
        this.dialog.ledgers.model.to = to;
        this.dialog.ledgers.model.merchantId = item.merchant_id;
        this.dialog.ledgers.show = true;
      }
    },

    data() {
      return {
        dates: [
          moment().startOf('isoWeek').subtract(1, 'w').format('YYYY-MM-DD'),
          moment().endOf('isoWeek').subtract(1, 'w').format('YYYY-MM-DD')
        ],
        scope: {
          acquirerId: null
        },
        acquirers: [ ],
        trustAccounts: [ ],

        form: {
          ach: {
            accountingPeriod: '1w'
          },
          search: {
            searchBy: '',
            keyword: '',
            queryString: ''
          },
          filter: {
            targetType: null,
            targetId: null
          }
        },
        targetTypes: [
          { label: '信託帳戶', value: 'trust_account' },
          // { label: '收單行', value: 'acquirer' },
          // { label: '組織', value: 'organization' },
          // { label: '商店', value: 'merchant' }
        ],
        targetEntities: [],
        isLoadingTargets: false,
        dialog: {
          transfer: {
            isLoading: false,
            show: false,
            menu: false,
            model: {
              from: null,
              to: null,
              schedule: moment().add(1, 'days').format('YYYY-MM-DD'),
              batchNo: '01'
            }
          },
          upload: {
            show: false,
            refId: undefined,
            description: '',
            uploadResult: { },
            errorRecords: { },
            errorRecordSchema: [
              { value: 'merchantId', text: 'Merchant' },
              { value: 'bankId', text: 'Rcpnt Bank' },
              { value: 'accountId', text: 'Rcpnt' },
              { value: 'accountNo', text: 'Rcpnt Account' },
              { value: 'amount', text: '$', align: 'right' },
              { value: 'note', text: 'Note' },
              { value: 'errorMsg', text: 'Error' }
            ]
          },
          ledgers: {
            isLoading: false,
            show: false,
            model: {
              from: null,
              to: null,
              merchantId: null
            }
          }
        }
      };
    },

    computed: {
      achByTrustAccount() {
        // 1. 取得開放日期 (openDate)
        const openDate = process.env.VUE_APP_ACH_BY_TRUST_ACCOUNT 
        ? moment(process.env.VUE_APP_ACH_BY_TRUST_ACCOUNT)
        : moment().add(1, 'd');
      
        // 2. 取得當前日期 (currentDate)
        const currentDate = moment();

        // 3. 進行比較並返回結果
        return currentDate.isSameOrAfter(openDate);
      },
      targetEntityDisplayKey() {
        // 根據不同的目標類型返回不同的顯示欄位
        switch(this.form.filter.targetType) {
          case 'trust_account':
            return 'accountName'; // 或是其他適合的欄位名稱
          case 'acquirer':
            return 'name';
          // case 'organization':
          //   return 'name'; // 或是 'org_name'
          // case 'merchant':
          //   return 'shop_name'; // 或是 'merchant_name'
          default:
            return 'accountName';
        }
      },

      loadUrl() {
        
        let from = moment(this.dates[0]).startOf('day');
        let to = moment(this.dates[1]).endOf('day');
        let url = '';

        // 根據選擇的類型添加 acquirerIds 參數
        if (this.achByTrustAccount) {
          // 一定要選擇出帳對象
          if (!this.form.filter.targetType || !this.form.filter.targetId) {
            return;
          }

          url = `${process.env.VUE_APP_QRPAY_ADMIN_HOST}/api/v2/remittances/preview?timeFormat=${encodeURIComponent('YYYY/M/D h:mm:ssA')}`
          + `&status=closed&from=${from.unix()}&to=${to.unix()}`
          + `&accountingPeriod=${this.form.ach.accountingPeriod}`
          + `${this.form.search.queryString}`;

          if (this.form.filter.targetType === 'trust_account') {
            // 信託帳戶：使用該帳戶關聯的所有 acquirer IDs
            const selectedAccount = this.targetEntities.find(t => t.id === this.form.filter.targetId);
            if (selectedAccount && selectedAccount.acquirers && selectedAccount.acquirers.length > 0) {
              const acquirerIds = selectedAccount.acquirers.map(a => a.id).join(',');
              url += `&acquirerIds=${acquirerIds}&trustAccountId=${this.form.filter.targetId}`;
            }
          } else if (this.form.filter.targetType === 'acquirer') {
            // 收單行：直接使用選中的 ID
            url += `&acquirerIds=${this.form.filter.targetId}`;
          }
        } else {
          // 一定要有收單行
          if (!this.scope.acquirerId) {
            return;
          }

          url = `${process.env.VUE_APP_QRPAY_ADMIN_HOST}/api/remittances/preview?timeFormat=${encodeURIComponent('YYYY/M/D h:mm:ssA')}`
          + `&status=closed&from=${from.unix()}&to=${to.unix()}`
          + `&accountingPeriod=${this.form.ach.accountingPeriod}`
          + `${this.form.search.queryString}`
          + `${this.scope.acquirerId? `&acquirerId=${this.scope.acquirerId}`: ''}`;
        }
        

        return url;
      },

      schema() {
        let _schema = [
          { value: 'merchant_id', text: this.$t('views.remittances.merchantId'), sortable: false },
          { value: 'shop_name', text: this.$t('views.remittances.shopName'), sortable: false },
          // { value: 'acquirer_id', text: this.$t('views.remittances.acquirerId'), sortable: false },
          { value: 'amount', text: this.$t('views.remittances.amount'), sortable: false, align: 'end', width: 128 },
          { value: 'service_fee', text: this.$t('views.remittances.serviceFee'), sortable: false, align: 'end', width: 128  },
          { value: 'transfer_fee', text: this.$t('views.remittances.transferFee'), sortable: false, align: 'end', width: 128  },
          { value: 'surcharge', text: this.$t('views.remittances.surcharge'), sortable: false, align: 'end', width: 128  },
          { value: 'dotdot_surcharge', text: this.$t('views.remittances.dotdotSurcharge'), sortable: false, align: 'end', width: 128  },
          { value: 'payable', text: this.$t('views.remittances.transferAmount'), sortable: false, align: 'end', width: 128  },
          { value: 'recipient', text: this.$t('views.remittances.recipient'), sortable: false },
          { value: 'invoice', text: this.$t('views.remittances.invoice.fieldTitle'), sortable: false },
          { value: 'actions', text: this.$t('views.cardpay.orders.actions'), sortable: false },
        ];

        if (this.achByTrustAccount) {
          _schema = [
            { value: 'merchant_id', text: this.$t('views.remittances.merchantId'), sortable: false },
            { value: 'shop_name', text: this.$t('views.remittances.shopName'), sortable: false },
            { value: 'amount', text: this.$t('views.remittances.amount'), sortable: false, align: 'end', width: 128 },
            { value: 'service_fee', text: this.$t('views.remittances.serviceFee'), sortable: false, align: 'end', width: 128  },
            { value: 'transfer_fee', text: this.$t('views.remittances.transferFee'), sortable: false, align: 'end', width: 128  },
            { value: 'surcharge', text: this.$t('views.remittances.surcharge'), sortable: false, align: 'end', width: 128  },
            { value: 'payable', text: this.$t('views.remittances.transferAmount'), sortable: false, align: 'end', width: 128  },
            { value: 'recipient', text: this.$t('views.remittances.recipient'), sortable: false },
            { value: 'invoice', text: this.$t('views.remittances.invoice.fieldTitle'), sortable: false },
            { value: 'actions', text: this.$t('views.cardpay.orders.actions'), sortable: false },
          ];
        }
        return _schema;
      },

      loadLedgersUrl() {
        if (!this.dialog.ledgers.model.merchantId) return;
        let from = moment(this.dates[0]).startOf('day');
        let to = moment(this.dates[1]).endOf('day');
        if (this.achByTrustAccount) {
          let url = `${process.env.VUE_APP_QRPAY_ADMIN_HOST}/api/v2/remittances/ledgers?timeFormat=${encodeURIComponent('YYYY/M/D h:mm:ssA')}`
            + `&from=${from.unix()}&to=${to.unix()}`
            + `&merchantId=${this.dialog.ledgers.model.merchantId}`;

          if (this.form.filter.targetType === 'trust_account') {
            // 信託帳戶：使用該帳戶關聯的所有 acquirer IDs
            const selectedAccount = this.targetEntities.find(t => t.id === this.form.filter.targetId);
            if (selectedAccount && selectedAccount.acquirers && selectedAccount.acquirers.length > 0) {
              const acquirerIds = selectedAccount.acquirers.map(a => a.id).join(',');
              url += `&acquirerIds=${acquirerIds}`;
            }
          } else if (this.form.filter.targetType === 'acquirer') {
            // 收單行：直接使用選中的 ID
            url += `&acquirerIds=${this.form.filter.targetId}`;
          }
          
          return url;
        } else {
          return `${process.env.VUE_APP_QRPAY_ADMIN_HOST}/api/remittances/ledgers?timeFormat=${encodeURIComponent('YYYY/M/D h:mm:ssA')}`
          + `&from=${from.unix()}&to=${to.unix()}`
          + `&merchantId=${this.dialog.ledgers.model.merchantId}`;
        }
        
      },

      ledgerSchema() {
        return [
          // { value: 'merchantId', text: this.$t('views.remittances.merchantId'), sortable: false },
          { value: 'createdAt', text: this.$t('views.ledgers.createdAt'), sortable: false },
          { value: 'paymentOrderId', text: this.$t('views.ledgers.paymentOrderId'), sortable: false },
          { value: 'acquirerId', text: this.$t('views.ledgers.acquirer'), sortable: false },
          { value: 'amount', text: this.$t('views.ledgers.amount'), sortable: false, align: 'end', width: 128 },
          { value: 'serviceFee', text: this.$t('views.ledgers.serviceFee'), sortable: false, align: 'end', width: 128  },
          { value: 'settledAt', text: this.$t('views.ledgers.settledAt'), sortable: false },
        ];
      },

      // 顯示選中的信託帳戶所包含的收單機構名稱
      selectedTrustAccountAcquirers() {
        if (this.form.filter.targetType !== 'trust_account' || !this.form.filter.targetId) {
          return '';
        }

        const selectedAccount = this.targetEntities.find(t => t.id === this.form.filter.targetId);
        if (!selectedAccount || !selectedAccount.acquirers || selectedAccount.acquirers.length === 0) {
          return '';
        }

        // 將所有收單機構名稱用逗號連接
        return selectedAccount.acquirers.map(a => a.acquirerName).join(', ');
      },

    }
  }
</script>
